<template>
  <div class="googleAuthBox">
    <nav-bar :title="$t('谷歌验证器')" bg-color="transparent" left-arrow left-color="#fff" title-color="#fff" />
    
    <!-- 已绑定状态 -->
    <div v-if="isBound" class="bindedBox">
      <div class="iconBox">
        <van-icon name="success-circle" size="40px" color="#07c160" />
      </div>
      <p class="title">{{ $t('您已成功绑定谷歌验证器') }}</p>
      <p class="desc">{{ $t('每次登录或进行敏感操作时，需要输入谷歌验证器生成的6位动态码') }}</p>
      <div class="unbindVerifyBox">
        <p class="verifyTitle">{{ $t('请输入谷歌验证器生成的6位动态码') }}</p>
        <van-field
          v-model="verificationCode"
          type="number"
          :placeholder="$t('请输入6位动态码')"
          maxlength="6"
          class="verifyInput"
        />
        <van-button type="primary" @click="unbindAuthenticator" :disabled="!verificationCode || verificationCode.length !== 6">
          {{ $t('解绑验证器') }}
        </van-button>
      </div>
    </div>
    
    <!-- 未绑定状态 -->
    <div v-else class="unbindedBox">
      <div class="qrcodeContainer">
        <qr-code v-if="secretKey" :text="qrCodeContent" :size="200" />
        <div v-else class="loadingBox">
          <van-loading type="spinner" color="#fff" />
          <p class="loadingText">{{ $t('获取密钥中...') }}</p>
        </div>
      </div>
      
      <div v-if="secretKey" class="secretKeyBox">
        <p class="keyTitle">{{ $t('密钥') }}</p>
        <p class="secretKey">{{ secretKey }}</p>
        <van-button type="text" @click="copyKey" class="copyBtn">
          <van-icon name="copy" color="#fff" />
          {{ $t('复制密钥') }}
        </van-button>
      </div>
      
      <div class="guideBox">
        <p class="guideTitle">{{ $t('绑定步骤') }}</p>
        <ol class="guideList">
          <li>{{ $t('1. 在手机上下载安装谷歌验证器App') }}</li>
          <li>{{ $t('2. 打开App，点击右上角的加号，选择「扫描条形码」') }}</li>
          <li>{{ $t('3. 扫描上方的二维码，或手动输入密钥') }}</li>
          <li>{{ $t('4. 输入App生成的6位动态码完成绑定') }}</li>
        </ol>
        
        <div class="verifyBox" v-if="secretKey">
          <van-field
            v-model="verificationCode"
            type="number"
            :placeholder="$t('请输入6位动态码')"
            maxlength="6"
            class="verifyInput"
          />
          <van-button type="primary" @click="bindAuthenticator" :disabled="!verificationCode || verificationCode.length !== 6">
            {{ $t('确认绑定') }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from '@/components/qr-code.vue'

export default {
  components: {
    QRCode
  },
  data() {
    return {
      isBound: false,
      secretKey: '',
      qrCodeContent: '',
      verificationCode: '',
      phone: '' // 用户手机号，用于生成二维码
    }
  },
  methods: {
    // 获取绑定状态
    getBindStatus() {
      this.$get({
        url: '/member/getGoogleAuthStatus',
        loading: true,
        success: (res) => {
          this.isBound = res.data.is_enabled || false
          if (!this.isBound) {
            this.getSecretKey()
          }
        },
        tip: () => {}
      })
    },
    
    // 获取新密钥
    getSecretKey() {
        this.$get({
          url: '/member/getGoogleAuthSecret',
          loading: true,
          success: (res) => {
            // 假设接口返回格式与获取状态接口相同
            if (res.code === 1 && res.status === 'success' && res.data) {
              this.secretKey = res.data.secret || ''
              const qr_code_url = res.data.qr_code_url || ''
              
              // 对qr_code_url进行URL解码
              this.qrCodeContent = decodeURIComponent(qr_code_url)
              
              // 从解码后的URL中提取手机号
              try {
                const decodedUrl = this.qrCodeContent
                // 匹配lt:后面的手机号部分，直到@符号
                const phoneMatch = decodedUrl.match(/lt:(\d+)@/)
                if (phoneMatch && phoneMatch[1]) {
                  this.phone = phoneMatch[1]
                }
              } catch (error) {
                console.error('提取手机号失败:', error)
              }
              
              this.$toast(res.message || this.$t('获取成功'))
            } else {
              this.$toast(res.message || this.$t('获取密钥失败'))
            }
          },
          tip: () => {}
        })
      },
    
    // 复制密钥
    copyKey() {
      const textarea = document.createElement('textarea')
      textarea.value = this.secretKey
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$toast.success(this.$t('密钥已复制'))
    },
    
    // 绑定验证器
    bindAuthenticator() {
      this.$post({
        url: '/member/bindGoogleAuth',
        loading: true,
        data: {
          secretKey: this.secretKey,
          code: this.verificationCode
        },
        success: (res) => {
          // 假设接口返回格式与获取状态接口相同
          if (res.code === 1 && res.status === 'success') {
            this.$toast.success(res.message || this.$t('绑定成功'))
            this.isBound = true
            this.verificationCode = ''
          } else {
            this.$toast(res.message || this.$t('绑定失败'))
          }
        },
        tip: () => {}
      })
    },
    
    // 解绑验证器
    unbindAuthenticator() {
      this.$dialog.confirm({
        title: this.$t('确认解绑'),
        message: this.$t('解绑后将无法使用谷歌验证器进行身份验证，是否继续？'),
        confirmButtonText: this.$t('确认'),
        cancelButtonText: this.$t('取消'),
        confirmButtonColor: '#ee0a24'
      }).then(() => {
        this.$post({
            url: '/member/unbindGoogleAuth',
            loading: true,
            data: {
              code: this.verificationCode
            },
            success: (res) => {
              // 假设接口返回格式与获取状态接口相同
              if (res.code === 1 && res.status === 'success') {
                this.$toast.success(res.message || this.$t('解绑成功'))
                this.isBound = false
                this.verificationCode = ''
                this.getSecretKey()
              } else {
                this.$toast(res.message || this.$t('解绑失败'))
              }
            },
            tip: () => {}
          })
      })
    }
  },
  created() {
    this.getBindStatus()
  }
}
</script>

<style lang="less" scoped>
.googleAuthBox {
  width: 100%;
  min-height: 100vh;
  background-color: #446D7A;
  padding: 15px;
  color: #fff;
  
  .bindedBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 60px;
      
      .iconBox {
        margin-bottom: 20px;
      }
      
      .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      
      .desc {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        margin-bottom: 40px;
        padding: 0 20px;
      }
      
      .buttonBox {
        width: 100%;
        padding: 0 20px;
      }
      
      .unbindVerifyBox {
        width: 100%;
        padding: 20px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        box-sizing: border-box;
        
        .verifyTitle {
          font-size: 16px;
          margin-bottom: 15px;
          text-align: center;
        }
        
        .verifyInput {
          margin-bottom: 20px;
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 5px;
          
          ::v-deep .van-field__control {
            color: #fff;
          }
          
          ::v-deep .van-field__placeholder {
            color: rgba(255, 255, 255, 0.6);
          }
        }
        
        .van-button {
          width: 100%;
          background-color: #ee0a24;
          border: none;
          font-size: 16px;
          
          &:disabled {
            background-color: #888;
          }
        }
      }
    }
  
  .unbindedBox {
    .qrcodeContainer {
      display: flex;
      justify-content: center;
      margin: 30px 0;
      padding: 20px;
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      
      .loadingBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 200px;
        
        .loadingText {
          margin-top: 10px;
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
    
    .secretKeyBox {
      background-color: rgba(255, 255, 255, 0.1);
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 30px;
      position: relative;
      
      .keyTitle {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 10px;
      }
      
      .secretKey {
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;
        text-align: center;
      }
      
      .copyBtn {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        color: #fff !important;
        padding: 0;
      }
    }
    
    .guideBox {
      background-color: rgba(255, 255, 255, 0.1);
      padding: 15px;
      border-radius: 8px;
      
      .guideTitle {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      
      .guideList {
        padding-left: 20px;
        margin-bottom: 20px;
        
        li {
          margin-bottom: 8px;
          line-height: 1.5;
          color: rgba(255, 255, 255, 0.9);
        }
      }
      
      .verifyBox {
        .verifyInput {
          margin-bottom: 15px;
          
          ::v-deep .van-field__control {
            color: #000000;
          }
          
          ::v-deep .van-field__input {
            color: #fff;
          }
        }
      }
    }
  }
  
  /* 适配vant组件样式 */
  ::v-deep .van-button--primary {
    background-color: #1989fa;
    border: none;
  }
  
  ::v-deep .van-button--text {
    color: #fff;
  }
  
  ::v-deep .van-dialog__content {
    color: #333;
  }
}
</style>